module.exports = __webpack_public_path__ + "staticcomp/img/top_share_bt.0977295.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top_share_bt.png
// module id = 2Vbh
// module chunks = 39